import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

import edMantra from "../../services/edMantra";
import { useSelector } from "react-redux";
import MarketingEditLead from "../../Components/EDLeadForm/MarketingEditLead";
import EDModal from "../../Components/EDModal/EDModal";
import { SiMicrosoftexcel } from "react-icons/si";
import leadsamplefile from "../../assets/files/leadsMarketing.xlsx";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineDelete, MdEdit, MdEmail } from "react-icons/md";
import MarketingAddLeads from "../../Components/EDLeadForm/MarketingAddLead";
import {
  FaFileDownload,
  FaFileExport,
  FaAddressCard,
  FaCloudUploadAlt,
} from "react-icons/fa";
import "./ManageMarketingLeads";
//import './Globalstyle'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, {
  textFilter,
  dateFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
  Search,
  CSVExport,
  pagination,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import loadinggif from "../../assets/images/loading.gif";

const ManageMarketingLeads = (props) => {
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const fileInputRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(50);
  const [allRemarks, setRemarks] = useState([]);
  const [leadObject, setLeadObject] = useState(null);
  const [allEmployees, setAllEmployees] = useState([]);
  const [leadData, setLeadData] = useState([]);
  const [editableRowIndex, setEditableRowIndex] = useState(null);
  const [file, setFile] = useState({});
  const [toggle, setToggle] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [audioFile, setAdudioFile] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  // State to store the IDs of selected leads
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [totalLeads, setTotalLeads] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [marketingExecutive, setMarketingExecutive] = useState([]);
  const [marketingManager, setMarketingManager] = useState([]);
  const [vendorManagementExecutive, setVendorManagementExecutive] = useState(
    []
  );
  const [page, setPage] = useState(1);
  const [vendorManagementManager, setVendorManagementManager] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // 👈 Add this
  const [totalPages, setTotalPages] = useState(1); // 👈 And this

  const handleEditButtonClick = (lead) => {
    setLeadObject(lead);
    setRemarks(lead.remarks);
    setShowModal(true);
  };

const fetchData = async (page = 1, limit = 25) => {
  setIsLoading(true);
  try {
    const response =
      data.role.roleName === "AdminDm" || data.role.roleName === "SuperAdmin"
        ? await edMantra.getMarketingLead(page, limit)
        : await edMantra.getMarketingLeadByEmpId(data?.empId, page, limit);

    const result = response.data;

    if (result && result.data) {
      setLeadData(result.data);
      setTotalLeads(result.totalCount || 0);        
      setTotalPages(result.totalPages || 0);
      setCurrentPage(result.currentPage || page);
    } else {
      setLeadData([]);
      setTotalLeads(0);                             
    }
  } catch (error) {
    console.error("Error fetching marketing leads:", error);
    setLeadData([]);
    setTotalLeads(0);                                
  } finally {
    setIsLoading(false);
  }
};


  const pagination = paginationFactory({
    page,
    sizePerPage,
    totalSize: totalLeads, // ✅ <- this MUST reflect total records in DB
    showTotal: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    onPageChange: (newPage) => setPage(newPage),
    onSizePerPageChange: (newSize, newPage) => {
      setSizePerPage(newSize);
      setPage(newPage); // ✅ Trigger fetchData on size change
    },
  });

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    // Fetch or update table data based on the new page or sort
    console.log("Table changed", type, page, sizePerPage);
  };

  const getAllEmployees = async () => {
    try {
      const allEmployees = await edMantra.getAllEmployees();
      setAllEmployees(allEmployees.data.data);
    } catch (err) {
      console.error(err, "Error fetching data");
    }
  };
  const handleFileChange = (e, index) => {
    setFile(e.target.files[0]);
    setToggle(!toggle);
  };
  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const result = await edMantra.uploadMaketingLeadeFile(formData);
      if (result.status === 200) {
        setToggle(false);
        setRefresh(!refresh);
        toast(result?.data?.message);
        setFile({});
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSave = async (val) => {
    try {
      const formData = new FormData();
      formData.append("lead_id", val.LeadId);
      formData.append("emp_id", data?.empId);
      const response = await edMantra.updateMarketingLeads(val.LeadId, {
        ...val,
        empId: data?.empId,
      });
      if (response.status === 200) {
      }
      setShowModal(false);
      toast(response.data.message);
      fetchData();
      setEditableRowIndex(null);
    } catch (error) {
      console.error(
        error.message || "An error occurred while updating the lead."
      );
    }
  };

  const handleDelete = async (lead) => {
    try {
      const result = await edMantra.deleteMarketingLeadByLeadId(lead.LeadId);
      if (result?.data.errorCode === 0) {
        toast.success("Lead Deleted successfully.");
        setRefresh(!refresh);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleButtonClick = () => {
    fileInputRef?.current?.click();
  };

  // Function to handle assigning telecaller
  const handleAssigneeUpdate = async (empId, userRemark = "") => {
    try {
      if (selectedRows.length === 0) {
        toast.error("Please select at least one row.");
        return;
      }

      const updatedRows = await Promise.all(
        selectedRows.map(async (row) => {
          if (!row?.LeadId || !empId) {
            console.warn("LeadId or empId missing in row:", row);
            return null;
          }

          // Construct the payload with required fields
          const payload = {
            LeadId: row.LeadId, // Lead ID must be present
            telecaller: empId, // Telecaller (empId) must be updated
            remark: userRemark || "", // Optional: If remark is provided, it will be included
            empId: empId, // empId is required in the body
            status: row.status, // Ensure other fields are passed correctly
          };

          try {
            const response = await edMantra.updateMarketingLeads(
              row.LeadId,
              payload
            );
            console.log("Success:", response.data);
            return response.data.updatedLead || response.data;
          } catch (err) {
            console.error(
              "Error updating LeadId:",
              row.LeadId,
              err?.response?.data || err.message
            );
            return null;
          }
        })
      );

      if (updatedRows.every((r) => r !== null)) {
        toast.success("Lead Assignee updated successfully.");
        fetchData(); // Refetch data or update UI as necessary
      } else {
        toast.error("Some updates failed.");
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("Something went wrong.");
    }
  };

  const getAllMarketingExecutive = async () => {
    const result = await edMantra.getAllMarketingExecutive();
    setMarketingExecutive(result?.data?.data);
  };
  const getAllMarketingManager = async () => {
    const result = await edMantra.getAllMarketingManager();
    setMarketingManager(result?.data?.data);
  };

  const getAllVendorManagementExecutive = async () => {
    const result = await edMantra.getAllVendorManagementExecutive();
    setVendorManagementExecutive(result?.data?.data);
  };

  const getAllVendorManagementManager = async () => {
    const result = await edMantra.getAllVendorManagementManager();
    setVendorManagementManager(result?.data?.data);
  };

  useEffect(() => {
    getAllEmployees();
    getAllMarketingManager();
    getAllMarketingExecutive();
    getAllVendorManagementExecutive();
    getAllVendorManagementManager();
  }, []);

  useEffect(() => {
    fetchData();
  }, [refresh]);

useEffect(() => {
  if (data?.empId) {
    fetchData(currentPage, sizePerPage);
  }
}, [currentPage, sizePerPage, data?.empId]);

  const openwhatsApp = async (phone) => {
    try {
      if (!phone.startsWith("+91")) {
        phone = "+91" + phone;
      }
      const whatsappUrl = `https://wa.me/${phone}`;
      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  const openEamil = (email) => {
    const recipient = email;
    const subject = "Subject of the email";
    const body = "Content of the email";
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handleAddlead = (params) => {
    setAddModal(true);
    setRefresh(!refresh);
  };

  const formatDateforleadinout = (dateString) => {
    //for lead craetedAt and updatedAt
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Include this option for 12-hour format
    };
    return date.toLocaleDateString("en-GB", options);
  };

  const formatDatefornextfollow = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Include this option for 12-hour format
    };
    return date.toLocaleDateString("en-GB", options);
  };

  //----------------bulkdelete----------------------------

  // Assuming you have a function to handle row deselection in your table
  const handleRowDeselect = (row) => {
    // Remove the deselected row's ID from selectedLeadIds state
    setSelectedLeadIds(selectedLeadIds.filter((id) => id !== row.LeadId));
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one row.");
      return;
    }

    try {
      const result = await edMantra.deleteBulkMarketingLead({
        leads: selectedRows,
      });

      if (result.data.errorCode === 0) {
        toast.success(result.data.message);
      } else {
        toast.error(result.data.message);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        // Handle known errors from server response
        toast.error(error.response.data.message || "Internal server error");
      } else {
        // Handle unknown errors
        toast.error("Internal server error");
      }
      console.error("Error in handleBulkDelete:", error);
    }
  };

  //---------------------------------

  //---------------source filter option--------------------

  const leadSources = [
    { value: "", label: "Select a source" }, // Default option
    { value: "Website", label: "Website" },
    { value: "Facebook Ad", label: "Facebook Ad" },
    { value: "Instagram Ad", label: "Instagram Ad" },
    { value: "Google Ad", label: "Google Ad" },
    { value: "Just Dial", label: "Just Dial" },
    { value: "Walk-In", label: "Walk-In" },
    { value: "Incoming Call", label: "Incoming Call" },
    { value: "Reference", label: "Reference" },
    { value: "Alumni", label: "Alumni" },
    { value: "Field Data", label: "Field Data" },
    { value: "Seminar", label: "Seminar" },
    { value: "Webinar", label: "Webinar" },
    { value: "Schools", label: "Schools" },
    { value: "Coaching's", label: "Coaching's" },
    { value: "Event", label: "Event" },
    { value: "Activities", label: "Activities" },
    { value: "Admission Centre", label: "Admission Centre" },
    { value: "Franchise", label: "Franchise" },
    { value: "Self-Generated", label: "Self-Generated" },
    { value: "Employment Mantras", label: "Employment Mantras" },
    { value: "Purchased Data", label: "Purchased Data" },
    { value: "WhatsApp", label: "WhatsApp" },
    { value: "WhatsApp Status", label: "WhatsApp Status" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "GMB", label: "GMB" },
    { value: "WhatsApp Group", label: "WhatsApp Group" },
    { value: "Other", label: "Other" },
    { Value: "Google", label: "Google" },
  ];
  const leadSourceFilter = selectFilter({
    options: leadSources,
  });
  //-----------------------------------------------------------
  const filterByMultipleEducation = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedEducation = filterValue
      .split(",") // Split input by commas
      .map((pincode) => pincode.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedEducation.includes(row.pincode.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleCity = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedCity = filterValue
      .split(",") // Split input by commas
      .map((city) => city.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedCity.includes(row.city.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleLocation = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedLocation = filterValue
      .split(",") // Split input by commas
      .map((location) => location.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedLocation.includes(row.location.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleCP = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedCP = filterValue
      .split(",") // Split input by commas
      .map((objective) => objective.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedCP.includes(row.objective.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleStatus = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedStatus = filterValue
      .split(",") // Split input by commas
      .map((status) => status.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedStatus.includes(row.status.toLowerCase()) // Check if row sector matches any selected industry
    );
  };
  const filterByMultipleInterest = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedInterest = filterValue
      .split(",") // Split input by commas
      .map((interestLevel) => interestLevel.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedInterest.includes(row.interestLevel.toLowerCase()) // Check if row sector matches any selected industry
    );
  };
  const filterByMultipleLeadSource = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedLeadSource = filterValue
      .split(",") // Split input by commas
      .map((source) => source.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter((row) => {
      const source = row.source; // Access 'source' instead of 'leadSources'
      // Ensure leadSource is a non-empty string before processing
      return (
        typeof source === "string" &&
        selectedLeadSource.includes(source.toLowerCase())
      );
    });
  };

  // -----------data table--------------------------------------------
  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      dataField: "SrNo",
      text: "Sr. No",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "clientName",
      text: "Full Name",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "collegeCategory",
      text: "College Category",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "pocName",
      text: "Contact No.",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "pocMobile",
      text: "Contact No.",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "pocEmail",
      text: "Email",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "address",
      text: "Address",
      sort: "true",
      filter: textFilter(),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "location",
      text: "Location",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter Location (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleLocation(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "objective",
      text: "Objective",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter Objective (comma-separated)", // Guide the user
        onFilter: (filterValue, data) => filterByMultipleCP(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "interestLevel",
      text: "Interest Level",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter Interest Level (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleInterest(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },

    {
      dataField: "status",
      text: "Status",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter status (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleStatus(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "source",
      text: "Source",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter status (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleLeadSource(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },

    {
      dataField: "preferredContactTiming",
      text: "Preferred Contact Timing",
      sort: "true",
      filter: textFilter(),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "nextfollow",
      text: "Next Follow Up Date",
      sort: "true",
      filter: dateFilter(),
      formatter: (cell, row) => formatDatefornextfollow(cell),
    },
    {
      dataField: "leadCreatedAt",
      text: "Create Time",
      sort: "true",
      filter: dateFilter(),
      formatter: (cell, row) => formatDateforleadinout(cell),
    },
    {
      dataField: "leadUpdatedAt",
      text: "Update Time",
      sort: "true",
      filter: dateFilter(),
      formatter: (cell, row) => formatDateforleadinout(cell),
    },
    {
      dataField: "telecaller",
      text: "Assign To",
      sort: "true",
      filter: selectFilter({
        options: allEmployees?.map((emp) => ({
          value: emp.empId,
          label: `${emp.fname} ${emp.lname}`,
        })),
        placeholder: "Select or Search by Name",
      }),
      formatter: (cell, row) => {
        const telecaller = allEmployees?.find(
          (emp) => emp?.empId === row?.telecaller
        );
        if (telecaller) {
          return `${telecaller.fname} ${telecaller.lname}`;
        } else {
          return "Not Assigned"; // Or any other placeholder text
        }
      },
    },

    {
      dataField: "source",
      text: "Lead Source",
      sort: true,
      filter: textFilter({
        placeholder: "Enter Source (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleLeadSource(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "actions", // Assuming 'actions' is the field in your data object that contains the actions data
      text: "Actions",
      formatter: (cell, row, rowIndex, extraData) => {
        if (editableRowIndex === rowIndex) {
          return (
            <>
              <button
                className="btn btn-outline-primary me-2"
                onClick={() => handleSave(row.LeadId, rowIndex)}
              >
                Save
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => setEditableRowIndex(null)}
              >
                Cancel
              </button>
            </>
          );
        } else {
          return (
            <>
              <div className="d-flex">
                <div>
                  <div className="mx-2 pointer-cursor">
                    <MdEdit
                      size={20}
                      color="black"
                      onClick={() => handleEditButtonClick(row)}
                    />
                  </div>
                </div>
                {data?.role?.roleName === "SuperAdmin" && (
                  <div className="mx-2 pointer-cursor">
                    <MdOutlineDelete
                      onClick={() => handleDelete(row)}
                      color="red"
                      size={20}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex">
                <div className="mx-2 pointer-cursor">
                  <FaWhatsapp
                    onClick={() => openwhatsApp(row?.mobile)}
                    size={20}
                    color="limegreen"
                  />
                </div>
                <div className="ms-2 pointer-cursor">
                  <MdEmail
                    style={{ cursor: "pointer" }}
                    onClick={() => openEamil(row.email)}
                    size={20}
                    color="#0072c6"
                  />
                </div>
              </div>
            </>
          );
        }
      },
    },
  ];

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    bgcolor: "red",
  };

  // Function to handle row selection
  const handleRowSelect = (row, isSelected) => {
    setSelectedRows([...selectedRows, row]);
  };
  console.log(selectedRows);

  // Function to handle row selection for all rows
  const handleRowSelectAll = (isSelected, rows) => {
    // Update selectedRows state when all rows are selected or deselected
    console.log(rows);
    if (isSelected) {
      setSelectedRows(rows);
    } else {
      setSelectedRows([]);
    }
  };
  //--------------data tabel--------------------------------------------

  const customPagination = paginationFactory({
    showTotal: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 }, // ✅ Allow 1000 rows per page
      { text: "5000", value: 5000 }, // ✅ Allow 1000 rows per page
    ],
    sizePerPage: 50, // Default rows per page
  });

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 card border-0">
            <p className="fs-3 fw-normal typed-text">Vendor Leads Management</p>
          </div>

          <div className="card col-md-4 col-sm-12 border-0">
            <div className="d-flex flex-wrap align-items-center">
              {data?.role?.roleName === "SuperAdmin" && toggle ? (
                <button
                  type="button"
                  className="btn btn-warning btn-sm mr-2"
                  onClick={handleUpload}
                >
                  <FaCloudUploadAlt color={"black"} size={20} /> Upload
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-warning btn-sm mr-2"
                    onClick={handleButtonClick}
                  >
                    <FaFileDownload color={"black"} size={20} />{" "}
                    <span className="">Import</span>
                  </button>

                  <a
                    href={leadsamplefile}
                    download
                    className="btn btn-warning btn-sm mr-2"
                  >
                    <FaFileExport color={"black"} size={20} /> Sample File
                  </a>

                  <button
                    type="button"
                    className="btn btn-warning btn-sm mr-2 mt-2"
                    onClick={() => handleAddlead()}
                  >
                    <FaAddressCard color={"black"} size={20} /> Add New Lead
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="card col-md-4  col-sm-12 border-0 ">
            <select
              className="form-select border-0 mb-2"
              aria-label="Default select example"
              name="select"
              onChange={(e) => handleAssigneeUpdate(e.target.value)}
            >
              <option value="Not assigned">Select Employee</option>
              {[
                ...marketingExecutive,
                ...marketingManager,
                ...vendorManagementExecutive,
                ...vendorManagementManager,
                ...allEmployees,
              ].map((item, index) => (
                <option key={index} value={item?.empId}>
                  {`${item?.fname} ${item?.mname} ${item?.lname}`}
                </option>
              ))}
            </select>

            <select
              className="form-select border-0 mb-2"
              aria-label="Default select example"
              onChange={(e) => {
                // Handle the update action when "Dead Lead" is selected
                if (e.target.value === "Delete Lead") {
                  handleBulkDelete();
                }
              }}
            >
              <option>Select Action</option>
              <option value="Delete Lead">Delete Selected Leads</option>
            </select>
          </div>

          <div className=" card col-md-12 border-0">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <img src={loadinggif} alt="Loading" />
              </div>
            ) : (
              <ToolkitProvider
                keyField="SrNo"
                data={leadData}
                columns={columns}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
              >
                {(props) => (
                  <div>
                    <ExportCSVButton
                      className="btn btn-success btn-sm mb-2 float-end"
                      {...(props.csvProps || {})}
                      filename="MantrasERP_Record.csv"
                    >
                      <SiMicrosoftexcel /> Export Record
                    </ExportCSVButton>

                    <div className="table-responsive cus-table">
                      <BootstrapTable
                        filter={filterFactory()}
                        bootstrap4
                        keyField="SrNo"
                        data={leadData}
                        columns={columns}
                        striped
                        remote
                        hover
                        condensed
                        pagination={pagination}
                        onTableChange={handleTableChange}
                        filterPosition="top"
                        selectRow={{
                          mode: "checkbox",
                          clickToSelect: true,
                          selected: selectedRows.map((r) => r.SrNo), // 👈 Extract SrNo for checkbox UI
                          onSelect: handleRowSelect,
                          onSelectAll: handleRowSelectAll,
                        }}
                      />
                    </div>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </div>

          <div className="card col-md-12 border-0">
            <div className="card bg-light m-2">
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <EDModal
                isOpen={showModal}
                handleClose={() => setShowModal(false)}
                size="xl"
              >
                <MarketingEditLead
                  handleSave={(obj) => handleSave(obj)}
                  leadObject={{ ...leadObject, remark: "" }}
                  allRemarks={allRemarks}
                />
              </EDModal>

              <EDModal
                isOpen={addModal}
                handleClose={() => setAddModal(false)}
                size="xl"
              >
                <MarketingAddLeads handleClose={(val) => setAddModal(false)} />
              </EDModal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageMarketingLeads;
